import React from 'react';

const Deals = () => {
    return (
        <div className="container">
            <h2>this is deals</h2>
        </div>
    );
};

export default Deals;